import { dialogStore } from "@ucl/library";
import { CreateBoltTaskForm } from "./CreateTaskForm";
import { RichTextEditorsOutputTextTypes } from "../../types/globalTypes";

export interface OpenCreateTaskDialogProps {
  apiBaseUrl: string;
  getAuthRequestHeader: () => Promise<Record<string, string>>;
  parentEntityId?: string;
  parentEntityType?: string;
  onSave?: () => void;
  onClose?: () => void;
  dialogId?: string;
}

export const openCreateTaskDialog = ({
  apiBaseUrl,
  getAuthRequestHeader,
  parentEntityId,
  parentEntityType,
  onSave,
  onClose,
  dialogId = "add-bolt-task-dialog",
}: OpenCreateTaskDialogProps) => {
  const closeDialog = () => {
    dialogStore.closeDialog(dialogId);
  };

  const close = () => {
    onClose?.();
    closeDialog();
  };

  const handleSave = () => {
    onSave?.();
    closeDialog();
  };

  dialogStore.openDialog(
    {
      id: dialogId,
      header: "Add Task",
      allowDragging: false,
      width: "800px",
      height: "800px",
      content: () => (
        <CreateBoltTaskForm
          parentEntityId={parentEntityId}
          parentEntityType={parentEntityType}
          onSave={handleSave}
          apiBaseUrl={apiBaseUrl}
          getAuthRequestHeader={getAuthRequestHeader}
          assigneeOdataUrl={`${apiBaseUrl}/odata/bolttaskassigneeodata`}
          customFieldConfigurationProps={{
            props: {},
            render: () => null,
          }}
          richTextEditorsOutputTextType={RichTextEditorsOutputTextTypes.HTML}
          onCancel={close}
        />
      ),
      close,
    },
    true
  );
};
